import api from './api';

const trainingsService = {
  // Listar treinamentos
  getTrainings: async () => {
    const response = await api.get('/trainings');
    return response.data;
  },

  // Obter treinamento específico
  getTraining: async (id) => {
    const response = await api.get(`/trainings/${id}`);
    return response.data;
  },

  // Criar treinamento (apenas GERENCIA)
  createTraining: async (formData) => {
    const response = await api.post('/trainings', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Atualizar treinamento (apenas GERENCIA)
  updateTraining: async (id, formData) => {
    const response = await api.put(`/trainings/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Deletar treinamento (apenas GERENCIA)
  deleteTraining: async (id) => {
    const response = await api.delete(`/trainings/${id}`);
    return response.data;
  },

  // Registrar visualização
  registerView: async (id, data = {}) => {
    const response = await api.post(`/trainings/${id}/view`, data);
    return response.data;
  },

  // Download de arquivo
  downloadFile: async (id) => {
    const response = await api.get(`/trainings/${id}/download`, {
      responseType: 'blob'
    });
    return response.data;
  }
};

export default trainingsService;

